<template>
    <div class="register_box">
      <h3>China Non-Ferrous Metals Membership Guidelines</h3>

      <div class="box1">
        <div class="verticalLine1"></div>
        <h4 class="title1">Member type</h4>
      </div>
      <div class="payTable">
          <el-table
              :data="tableData"
              border
              style="width: 100%;font-size: 16px">
            <el-table-column
                prop="typeName"
                label="Member type"
                width="150">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Brief description">
            </el-table-column>
            <el-table-column
                prop="fees"
                label="Membership Fee (RMB/year)"
                width="220"
            >
            </el-table-column>
          </el-table>
        </div>

      <div class="box2">
        <div class="verticalLine1"></div>
        <h4 class="title1">Member of the power</h4>
      </div>
      <div class="watchThing1">
          <el-card class="box-card">
            <div v-for="item in data1" :key="item" class="text item">
              {{item}}
            </div>
          </el-card>
        </div>

      <div class="box2">
        <div class="verticalLine1"></div>
        <h4 class="title1">Member obligations</h4>
      </div>
      <div class="watchThing1">
        <el-card class="box-card">
          <div v-for="item in data2" :key="item" class="text item">
            {{item}}
          </div>
        </el-card>
      </div>

      <div class="box3">
        <el-checkbox  v-model="checked">I have read and agree
          <el-link type="primary" href="#/serviceAgreement" target="_blank">《User Service Agreement》</el-link>
          <el-link type="primary" href="#/privacyPolicy" target="_blank">《Privacy policy》</el-link>And the above terms</el-checkbox>
      </div>
      <el-button :disabled="!checked" :type="checked? 'primary' :'info'" class="footer" @click="change">The next step</el-button>
    </div>
</template>

<script>
export default {
  name:'VipRegister',
  props: {
    user: {
      type: Object
    },
  },
  data () {
    return {
      checked:false,
      tableData:[],
      data1:['1. The right to vote, stand for election and vote',

        '2. Have priority to participate in the activities of the Association, and can obtain the relevant academic materials and information of the Association at a discount or free of charge',

      "3. to obtain the priority of the association's services, can be prefered to participate in the organization of the demonstration, evaluation, appraisal and technical consultation and other activities",

      '4. The right to criticize and suggest and supervise the work of the Society',

      '5. Membership is voluntary and withdrawal is free.'


  ],
      data2:["1. Abide by the articles of Association and implement the resolutions of the Association",

        "2. Pay membership dues on time in accordance with the articles of Association",

        "3. Complete the work assigned by the institute",

        "4. Safeguard the legitimate rights and interests of the Association",

        "5. Report the situation to the Academy and provide relevant information.",

        "6. Other obligations stipulated in the Articles of Association."
      ]
    }
  },

  methods: {
    //取消按钮
    toLogin(){
      this.$router.push('/login')
    },
    change(){
      this.$store.dispatch('addActive1');
    },
    async getTable(){
      const { data: res } = await this.$http.post('/api/vip/vipType/allInfo')
      this.tableData = res
      // console.log(res);
    }
  },
  created() {
    this.getTable()
  }
}
</script>

<style lang="less" scoped>
.register_box{
  width: 100%;
  height: 100%;
}
h3{
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.verticalLine1{
  width: 5px;
  height: 35px;
  display: flex;
  float: left;
  margin-left: 15px;
  margin-top: 5px;
  background-color:#409EFF;
}
.title1{
  float: left;
  display: flex;
  margin: 8px 0 0 25px;
  color: #409EFF;
}
.payTable{
  width: 95%;
  padding: 10px 0 0 25px;
}
.box1{
  width: 100%;
  //background-color: red;
  height: 50px;
  margin-top: 80px;
}
.box2{
  width: 100%;
  //background-color: red;
  height: 50px;
  margin-top: 40px;
}
.watchThing1{
  width: 100%;
  margin-top: 15px;
}
.box-card{
  width: 90%;
 margin-left: 45px;
}

.box3{
  width: 100%;
  //background-color: red;
  height: 50px;
  //margin: 40px 0 0 40px;
  //position: absolute;
  //bottom: 50px;
  //left: 40px;
  margin-top: 25px;
}
.footer{
  //position: absolute;
  //bottom: 0;
  //height: 50px;
  width: 100%;
  text-align: center;
  font-size: 24px;
  border: none;
}
</style>
